import { Dispatch } from 'redux';
import api from '../services/api';
import { UserExpectedRenewal } from '../types/state';
import { handleError } from './dashboard';
export const LEM_ACTIONS = {
  LEM_LOADING: 'LEM_LOADING',
  MS_LOADING: 'MS_LOADING',
  LEM_DATA: 'LEM_DATA',
  MS_DATA: 'MS_DATA',
  LEM_SELECTED_PROPERTY: 'LEM_SELECTED_PROPERTY',
  LEM_SELECTED_BED: 'LEM_SELECTED_BED',
  LEM_GET_MANAGED_PROPERTIES: 'LEM_GET_MANAGED_PROPERTIES',

  LEM_GET_USER_EXPECTED_RENEWALS: 'LEM_GET_USER_EXPECTED_RENEWALS',
  LEM_UPDATE_USER_EXPECTED_RENEWALS: 'LEM_UPDATE_USER_EXPECTED_RENEWALS',
};
export const getLemData = (offerCycle: string) => (dispatch: Dispatch) => {
  dispatch({
    type: LEM_ACTIONS.LEM_LOADING,
    payload: true,
    meta: {
      track: true,
    },
  });
  api
    .getLemData({ offer_cycle: offerCycle })
    .then((res) => {
      dispatch({
        type: LEM_ACTIONS.LEM_DATA,
        payload: res.data,
        meta: {
          track: true,
        },
      });
    })
    .catch((err) => {
      console.log(err.response);
      handleError(err, dispatch);
    })
    .finally(() => {
      dispatch({
        type: LEM_ACTIONS.LEM_LOADING,
        payload: false,
        meta: {
          track: true,
        },
      });
    });
};

export const getMarketStrength = () => (dispatch: Dispatch) => {
  dispatch({
    type: LEM_ACTIONS.MS_LOADING,
    payload: true,
    meta: {
      track: true,
    },
  });
  api
    .getMarketStrength()
    .then((res) => {
      dispatch({
        type: LEM_ACTIONS.MS_DATA,
        payload: res.data,
        meta: {
          track: true,
        },
      });
    })
    .catch((err) => {
      console.log(err.response);
      handleError(err, dispatch);
    })
    .finally(() => {
      dispatch({
        type: LEM_ACTIONS.MS_LOADING,
        payload: false,
        meta: {
          track: true,
        },
      });
    });
};

export const setLemSelectedProperty =
  (selectedProperty: string) => (dispatch: Dispatch) => {
    dispatch({
      type: LEM_ACTIONS.LEM_SELECTED_PROPERTY,
      payload: selectedProperty,
      meta: {
        track: true,
      },
    });
  };

export const setLemLoading = (isLoading: boolean) => (dispatch: Dispatch) =>
  dispatch({
    type: LEM_ACTIONS.LEM_LOADING,
    payload: isLoading,
    meta: {
      track: true,
    },
  });
export const setLemSelectedBed = (bed: string) => (dispatch: Dispatch) =>
  dispatch({
    type: LEM_ACTIONS.LEM_SELECTED_BED,
    payload: bed,
    meta: {
      track: true,
    },
  });

export const getUserExpectedRenewals = () => (dispatch: Dispatch) => {
  dispatch({
    type: LEM_ACTIONS.LEM_LOADING,
    payload: true,
    meta: {
      track: true,
    },
  });
  api
    .getUserExpectedRenewals()
    .then((res) => {
      dispatch({
        type: LEM_ACTIONS.LEM_GET_USER_EXPECTED_RENEWALS,
        payload: res.data,
        meta: {
          track: true,
        },
      });
    })
    .catch((err) => {
      handleError(err, dispatch);
      console.log(err.message);
    })
    .finally(() => {
      dispatch({
        type: LEM_ACTIONS.LEM_LOADING,
        payload: false,
        meta: {
          track: true,
        },
      });
    });
};

export const UpdateUserExpectedRenewals =
  (params: UserExpectedRenewal, expiries: string | number) =>
  (dispatch: Dispatch) => {
    if (
      parseInt(params.Renewal.toString(), 10) >
      parseInt(expiries.toString(), 10)
    ) {
      dispatch({
        type: 'SHOW_NOTIFICATIONS',
        payload: {
          message: `Target Renewals cannot be greater than Expiring Leases.`,
          type: 'info',
        },
      });
      return;
    } else if (parseInt(params.Renewal.toString(), 10) < 0) {
      dispatch({
        type: 'SHOW_NOTIFICATIONS',
        payload: {
          message: `Target renewal  cannot be less than 0.`,
          type: 'info',
        },
      });
      return;
    }

    api
      .updateUserExpectedRenewals(params)
      .then((res) => {
        dispatch({
          type: 'SHOW_NOTIFICATIONS',
          payload: {
            message: `Target renewal  ${
              res.data.success ? 'updated successfully.' : 'update failed.'
            }`,
            type: res.data.success ? 'success' : 'info',
          },
        });
        if (res.data.success) {
          dispatch({
            type: LEM_ACTIONS.LEM_UPDATE_USER_EXPECTED_RENEWALS,
            payload: params,
            meta: {
              track: true,
            },
          });
        }
      })
      .catch((err) => {
        handleError(err, dispatch);
        console.log(err.message);
      })
      .finally(() => {});
  };
